export default __webpack_public_path__ + "static/media/el-salvador.cf8015ca.svg";